export default __webpack_public_path__ + "static/media/vajrada_amethyst_chunk.de93ac55.png";